import { Box, Chip, CircularProgress, IconButton } from "@mui/material";
import { RequestContext } from "../models/request";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Container, FormGroup, HeroButton, Icon, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner, Table, TextArea } from "design-react-kit";
import React from "react";
import { Payment, paymentStatus } from "../../payments/models/payment";
import ApiService from '../../../services/api';
import { ActaAuthContext } from "pa_kit/auth";
import Select from 'react-select';
import parse from 'html-react-parser';

const RequestControlPayments = (props:any) => {

    const [isLoading, setIsLoading]     = useState(true);
    const [isModalListOpen, setModalListOpen]   = useState(false);
    const [isModalAddOpen, setModalAddOpen]   = useState(false);
    const [payments, setPayments]       = useState([]);
    const [hasErrors, setHasErrors]       = useState(false);
    
    const requestInterface = React.useContext(RequestContext);
    const auth = useContext<any>(ActaAuthContext);
    const user = auth.user;
    
    var request = props.request;
    if(!request){
        request = requestInterface.request;
    }


    const [addPaymentAmount, setAddPaymentAmount]   = useState<string>("");
    const [addPaymentReason, setAddPaymentReason]   = useState<string>(request.module.name);
    const [addPaymentNote, setAddPaymentNote]       = useState<string>("");
    const [addPaymentIuv, setAddPaymentIuv]         = useState<string|undefined>();
    const [addPaymentService, setAddPaymentService] = useState<number|undefined>();
    const [addPaymentRef, setAddPaymentRef]         = useState<string>("");
    const [addPaymentNotify, setAddPaymentNotify]   = useState(true);

    useEffect(() => {
        fetchPayments();
    }, []);

    const resetForm = () => {
        setHasErrors(false);
        setAddPaymentAmount("");
        setAddPaymentReason(request.module.name);
        setAddPaymentNote("");
        setAddPaymentIuv(undefined);
        setAddPaymentService(undefined);
        setAddPaymentRef("");
        setAddPaymentNotify(true);
    }

    const fetchPayments = async () => {
        let result = [];

        if(request.paymentsCount !== 0){
            result = await ApiService.getPayments(request);
        }

        setPayments(result);
        setIsLoading(false);
    }

    const addNewPayment = async () => {
        setIsLoading(true);
        setHasErrors(false);
        try {
            await ApiService.createPayment(request, Number(addPaymentAmount), addPaymentReason, Number(addPaymentService), addPaymentRef, addPaymentIuv, addPaymentNote, addPaymentNotify);
            setModalListOpen(true);
            setModalAddOpen(false);
            await fetchPayments();
        } catch(e) {
            setIsLoading(false);
            setHasErrors(true);
        }
    } 

    const setAddPaymentServiceRef = (selectedOption:any) => {
        
        request.module.required_payments.forEach((payment:any) => {
            if(payment["serviceId"] === selectedOption["value"]){
                setAddPaymentService(payment["serviceId"]);
                setAddPaymentRef(payment["refType"]);
            }
        });

    }

    if(request.module.required_payments == null){
        return <></>;
    }

    const requiredPayments = request.module.required_payments.map((payment:any) => {
        return {
            value: payment['serviceId'], 
            label: "[" + payment['serviceId'] + "] " + payment['refType']
        };
    });






    var requestPaymentStatus:any = paymentStatus.none;
    var statusLabel = payments.length.toString();
    if(payments.find((payment:Payment) => payment.status === "notPaid")){
        requestPaymentStatus = paymentStatus.notPaid;
        statusLabel = "in attesa di pagamento";
    }else if(payments.find((payment:Payment) => payment.status === "processing")){
        statusLabel = "elaborazione pagamento in corso...";
        requestPaymentStatus = paymentStatus.processing;
    }else if(payments.find((payment:Payment) => payment.status === "paid")){
        requestPaymentStatus = paymentStatus.paid;
        //statusLabel = "pagamento effettuato";
    }else if(payments.find((payment:Payment) => payment.status === "error")){
        requestPaymentStatus = paymentStatus.error;
        //statusLabel = "errore di elaborazione pagamenti";
    }

    return (
        <>
            {isLoading ? (
                <CircularProgress size={21} thickness={3} color="info" sx={{margin:"3px"}} />
            ):(
                <Chip 
                    icon={<Icon icon="it-card" style={{ paddingRight: "-12px" }} color={requestPaymentStatus?.color} />} 
                    label={!props.extended ? payments.length : statusLabel}
                    color={requestPaymentStatus !== paymentStatus.none ? requestPaymentStatus.color : undefined } 
                    variant="outlined"
                    onClick={() => setModalListOpen(true)}
                />
            )}

            {/*
            <IconButton onClick={() => setModalListOpen(true)}>
                {isLoading ? (
                    <CircularProgress size={21} thickness={3} color="info" sx={{margin:"3px"}} />
                ):(
                    <Icon icon="it-card" color={requestPaymentStatus.color} />
                )}
            </IconButton>
            */}
            <Modal isOpen={isModalListOpen} toggle={() => setModalListOpen(!isModalListOpen)} size="xl" labelledBy='payments' zIndex={9999}>
                <ModalHeader toggle={() => setModalListOpen(!isModalListOpen)} id='payments'>
                    Stato pagamenti
                </ModalHeader>
                {isLoading ? (
                        <Box alignSelf={"center"} padding={12}>
                            <Spinner active />
                        </Box>
                ) : (
                    <>
                        <ModalBody>
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th scope='col'>Data richiesta pagamento</th>
                                        <th scope='col'>IUV</th>
                                        <th scope='col'>Importo</th>
                                        <th scope='col'>Stato</th>
                                        <th scope='col'>Data pagamento/Note</th>
                                        {/*
                                        <th scope='col'>Metodo</th>
                                        */}
                                        <th scope='col'>Azioni</th>
                                    </tr>
                                </thead>
                                    {payments.map((payment:Payment) => 
                                        <tr>
                                            <td className="py-2" style={{ verticalAlign: "middle" }}><small>{payment.created.toLocaleString()}</small></td>
                                            <td><small>{payment.iuv}</small></td>
                                            <td>
                                                {(payment.amount > 0) && (
                                                    <small>{payment.amount} €</small>
                                                )}
                                            </td>
                                            <td><Chip label={paymentStatus[payment.status].label} color={paymentStatus[payment.status].color} variant="outlined" /></td>
                                            { 
                                                (payment.isPaid) ? (
                                                    <td><small>{payment.paymentDate?.toLocaleString()}</small></td>
                                                ):(
                                                    <td><small>{ parse(payment.note) }</small></td>
                                                )
                                            }
                                            <td>
                                                {!user.hasPermissions() && payment.canBePaid && (
                                                    <HeroButton onClick={() => {
                                                        setIsLoading(true);
                                                        //console.log(payment);
                                                        ApiService.initPayment(payment).then((redirectUrl) => {
                                                            setIsLoading(false);
                                                            window.location.href = redirectUrl;
                                                            //window.open(redirectUrl);
                                                        });
                                                    }}>PAGA ORA</HeroButton>
                                                )}
                                                {false && payment.isPaid && (
                                                    <HeroButton onClick={() => {
                                                    }}>SCARICA RICEVUTA</HeroButton>
                                                )}
                                            </td>
                                        </tr>
                                    )}
                                <tbody>
                                </tbody>
                            </Table>
                        </ModalBody>
                        <ModalFooter>
                            <Button color='secondary' onClick={() => setModalListOpen(false)}>
                                Chiudi
                            </Button>
                            {user.hasPermissions() && (
                                <Button color='primary' onClick={() => {
                                        resetForm();
                                        setModalAddOpen(true);
                                        setModalListOpen(false);
                                    }}>
                                    Richiedi nuovo pagamento
                                </Button>
                            )}
                        </ModalFooter>
                    </>
                )}
            </Modal>
            <Modal isOpen={isModalAddOpen} toggle={() => setModalAddOpen(!isModalAddOpen)} size="xl" labelledBy='esempio13'>
                <ModalHeader toggle={() => setModalAddOpen(!isModalAddOpen)} id='esempio13'>
                    Richiedi nuovo pagamento
                </ModalHeader>
                {isLoading ? (
                        <Box alignSelf={"center"} padding={12}>
                            <Spinner active />
                        </Box>
                ) : (
                    <>
                        <ModalBody>
                            <div>
                                <Container>
                                    <Row style={{ height: "100px" }}>
                                        <Col>
                                            <div className='bootstrap-select-wrapper'>
                                                <label htmlFor='selectExampleClassic'>Etichetta di esempio</label>
                                                <Select
                                                    id='selectExampleClassic'
                                                    onChange={setAddPaymentServiceRef}
                                                    options={requiredPayments}
                                                    placeholder='Scegli il servizio di riferimento'
                                                    aria-label='Scegli il servizio di riferimento'
                                                    value={requiredPayments.filter(function(option:any) {
                                                      return option.value === addPaymentService;
                                                    })}
                                                    menuPortalTarget={document.body} 
                                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                />
                                            </div>
                                            {hasErrors && addPaymentService === undefined && (
                                                <div className='text-danger mx-2'><small>Questo campo è obbligatorio</small></div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Input type='text' label='IUV' 
                                                value={addPaymentIuv} 
                                                onChange={(ev) => { setAddPaymentIuv(ev.target.value)}}
                                                infoText="Se non indicato una nuova posizione verrà creata automaticamente con i dati forniti."
                                            />
                                        </Col>
                                        <Col>
                                            <Input type='number' label='Importo (€)' step={0.01} 
                                                value={addPaymentAmount} 
                                                onChange={(ev) => { setAddPaymentAmount(ev.target.value)}}
                                                required={true}
                                                min={0.10}
                                            />
                                            {hasErrors && addPaymentAmount === "" && (
                                                <div className='text-danger mx-2' style={{ marginTop: "-3rem" }}><small>Questo campo è obbligatorio</small></div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="mb-4">
                                        <Col>
                                            <Input type='text' label='Causale'
                                                value={addPaymentReason} onChange={(ev) => { setAddPaymentReason(ev.target.value)}} />
                                            {hasErrors && addPaymentReason === "" && (
                                                <div className='text-danger mx-2' style={{ marginTop: "-3rem" }}><small>Questo campo è obbligatorio</small></div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="mb-4">
                                        <Col>
                                            <TextArea rows={3} label='Note' 
                                                value={addPaymentNote} onChange={(ev) => { setAddPaymentNote(ev.target.value)}} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup check>
                                                <Input type='checkbox' id='checkbox1' 
                                                    checked={addPaymentNotify} onChange={(ev) => { setAddPaymentNotify(ev.target.checked)}} />
                                                <Label for='checkbox1'>Notifica il pagamento al richiedente.</Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button color='secondary' onClick={() => {
                                    setModalListOpen(true);
                                    setModalAddOpen(false);
                                }}>
                                Annulla
                            </Button>
                            <Button color='primary' onClick={() => addNewPayment()}>
                                Richiedi nuovo pagamento
                            </Button>
                        </ModalFooter>
                    </>
                )}
            </Modal>
        </>
    );
 }
 export default RequestControlPayments;